module.exports = __webpack_public_path__ + "static/media/CheckNota.1d6e4787.svg";